import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'photo'
})
export class PhotoPipe implements PipeTransform {

  transform(photo: string, height?: number): string {
    if(photo) return `${environment.api_url}/public/file/${encodeURIComponent(photo)}?disposition=inline`;
    if(height) return `assets/layout/images/icons/user-circlex${height}.png`;
    return `assets/layout/images/icons/user-circle.png`;
  }

}
